// extracted by mini-css-extract-plugin
export var content = "_ak-3";
export var list = "_ak-4";
export var settingsContent = "_ak-7";
export var settingsPanel = "_ak-8";
export var state = "_ak-6";
export var triggerBadge = "_ak-2";
export var triggerButton = "_ak-1";
export var triggerShell = "_ak-0";
export var unreadDot = "_ak-5";